import { useList } from '@refinedev/core';
import { FormField } from '@/components/forms';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { TriggerAction } from '../../types';

interface BroadcastFormProps {
  action: TriggerAction;
  onChange: (patch: Partial<TriggerAction>) => void;
}

/**
 * BroadcastForm
 * 
 * Форма действия отправки broadcast
 * 
 * @returns {React.ReactElement} React компонент
 */
export function BroadcastForm({ action, onChange }: BroadcastFormProps) {
  const { result: broadcastsResult } = useList<{ id: number; name: string }>({
    resource: 'broadcasts',
    pagination: { currentPage: 1, pageSize: 200, mode: 'server' },
  });

  const broadcasts = broadcastsResult.data ?? [];

  return (
    <FormField label="Рассылка" name="broadcastId">
      <Select
        value={action.broadcastId ?? 'none'}
        onValueChange={(v) => onChange({ broadcastId: v === 'none' ? undefined : v })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Выберите рассылку" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Выберите рассылку</SelectItem>
          {broadcasts.map((broadcast) => (
            <SelectItem key={broadcast.id} value={String(broadcast.id)}>
              {broadcast.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
